import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/siteInfo';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '17c.com',
      url: 'https://17c.com',
      description: siteInfo.description,
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        addressLocality: '深圳',
        addressRegion: '广东',
        addressCountry: 'CN',
      },
    },
    {
      '@type': 'WebSite',
      name: '17c.com',
      url: 'https://17c.com',
      description: siteInfo.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://17c.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '17c.com 首页',
      url: 'https://17c.com/',
      description: '17c.com官方入口，提供最新官方地址、安全入口及完整使用指南',
      isPartOf: {
        '@type': 'WebSite',
        name: '17c.com',
        url: 'https://17c.com',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="17c.com官方入口·最新地址直达 - 17c.com安全访问平台"
        description="17c.com是您信赖的访问平台，提供17c.com最新官方地址、安全入口及完整使用指南。稳定流畅的访问体验，立即进入17c.com探索更多精彩内容。"
        keywords="17c.com,17c.com官方地址,17c.com最新入口,17c.com安全访问,17c.com使用指南"
        canonicalUrl="https://17c.com/"
      />
      <SchemaOrg data={homeSchema} id="home" />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <CategorySection />
          <ArticleSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}